export default "__VITE_ASSET__Mr1vkhNT__"